import { Component, OnInit, OnDestroy, Injector, ViewChild } from '@angular/core';
import { forkJoin, Subscription } from 'rxjs';

// components
import { FullListComponent } from '../../shared/components/full-list/full-list.component';
import { LookupTableComponent } from './lookup-table.component';

// models
import { LookupTable } from '../shared/models/lookup-table';

// services
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../shared/services/language.service';

import { LookupTableService } from '../shared/services/lookup-table.service';


@Component({
  selector: 'lookup-tables-component',
  templateUrl: 'lookup-tables.component.html',
  styleUrls: ['./lookup-tables.component.scss']
})
export class LookupTablesComponent extends FullListComponent<LookupTable, LookupTableComponent> implements OnInit, OnDestroy {

  @ViewChild('confirmation') confirmation: any;
  @ViewChild('details') detailsComponent: LookupTableComponent;

  rtlEnabled = localStorage.getItem('last-selected-language-direction') ? JSON.parse(localStorage.getItem('last-selected-language-direction')) : false;
  private _subscription: Subscription;

  constructor(
    protected injector: Injector,
    private languageService: LanguageService,
    private translateService: TranslateService,
    private dataService: LookupTableService
  ) {
    super(injector, LookupTable);
    this.title.set('LOOKUP_TABLE.TITLE');

    this._subscription = this.languageService.direction.subscribe(dir => {
      this.rtlEnabled = dir;
    });
  }

  ngOnInit() {
    this.setTranslations('LOOKUP_TABLE');
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this._subscription.unsubscribe();
  }

  getData() {
    this.spinner.show();
    forkJoin(
      this.dataService.getLookupTables(null, this.id, this.translateService.currentLang)
    ).subscribe(result => {
      this.items = result[0];
      this.spinner.hide();
    },
      error => {
        this.errorService.show(error);
        this.spinner.hide();
      });
  }

  edit = (e: any) => {
    this.detailsComponent.modalTitle = this.translations.EDIT;
    this.detailsComponent.open(this.items, e.row.data.lookupTableId);
  }

  deleteItem = (e: any) => {
    this.itemIdToDelete = e.row.data.lookupTableId;
    this.confirmation.opened = true;
  }

  add() {
    this.detailsComponent.modalTitle = this.translations.ADD_NEW;
    this.detailsComponent.open(this.items, null);
  }

  openLookupTableListEditor = (e: any) => {
    this.router.navigate(['/auction/lookuptables/' + this.id + '/lookuptableeditor/' + e.row.data.lookupTableId]);
  }

  openLookupTablesEditorClick = (e: any) => {
    if (e.column.type !== 'buttons') {
      this.router.navigate(['/auction/lookuptables/' + this.id + '/lookuptableeditor/' + e.data.lookupTableId]);
    }
  }

  deleteSelected() {
    this.spinner.show();
    this.dataService.delete(this.itemIdToDelete, this.id)
      .subscribe((users: Array<LookupTable>) => {
        this.getData();
        this.spinner.hide();
      },
        () => {
          this.errorService.show(this.errorService.translations.DELETE_ERROR_MESSAGE);
          this.spinner.hide();
        });
  }

  getlookupTableTypeName = (e: any) => {
    if (e.value === 0) {
      return this.translate.instant('SHARED.FILTER');
    } else {
      return this.translate.instant('SHARED.DEFAULT_VALUE');
    }
  }
}
